import React from "react";
import helpicon from "../../../images/helpicon.svg";
import { Tooltip } from "antd";
import { Title5 } from "../Typography/Titles";

interface CustomLabelProps {
  labelTitle: string;
  isHelpIconRequired: boolean;
  tooltipText?: string | React.ReactNode;
  isRequired?: boolean;
  htmlFor?: string;
}
const CustomLabel: React.FC<CustomLabelProps> = ({ labelTitle, isHelpIconRequired, tooltipText, htmlFor, isRequired }) => {

  return (
    <div className="label-container flex items-center">
      <span className="label-title font-medium text-gray-800">
        {labelTitle === "Select Job Titles" || labelTitle === "Cc" ? (
          <Title5 text={labelTitle} color="text-text-secondary" className="font-semibold" />
        ) : (labelTitle === "Additional Information") ? (
          <>
            <div style={{ color: '#344054', fontSize: 14, fontFamily: 'Inter', fontWeight: '600', wordWrap: 'break-word' }}>
              Additional Information <span className="required-indicator text-primary">*</span>
            </div>
          </>
        ) : (
          <>
            {labelTitle} {isRequired && <span className="required-indicator text-primary">*</span>}
          </>
        )}
      </span>
      {isHelpIconRequired && tooltipText && (
        <Tooltip
          title={
            <span style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {tooltipText}
            </span>
          }
        >
          <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
        </Tooltip>
      )}
    </div>
  );
};

export default CustomLabel;
